// 正規表現を使った処理をまとめたファイル。
/**
 * 全角カナのみの文字列であるかを判別する。
 * @param value チェックしたい文字列。
 */
export function isFullWidthKana(value: string) {
  const FULL_WIDTH_KANA = RegExp("^[ァ-ヶ]+$");
  return FULL_WIDTH_KANA.test(value);
}

/**
 * 数字のみの文字列であるかを判別する。
 * @param value チェックしたい文字列。
 */
export function isNumber(value: string) {
  const NUMBER = RegExp("^[0-9]+$");
  return NUMBER.test(value);
}

export function isACMNumber(value: string) {
  const ACM_NUMBER_CHECK = RegExp(/^\d{10}$/)
  return ACM_NUMBER_CHECK.test(value);
}

/**
 * メールアドレスの形式となっている文字列であるかを判別する。
 * @param value チェックしたい文字列。
 */
export function isEmail(value: string) {
  const EMAIL = RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$");
  return EMAIL.test(value);
}

/**
 * 文字のみの（空白や絵文字、記号などを含まない）文字列であるかを判別する。
 * @param value チェックしたい文字列。
 */
export function isLetter(value: string) {
  const LETTER = RegExp(/^(\p{Script=Hiragana}|\p{Script_Extensions=Katakana}|\p{Script_Extensions=Han}|[a-zA-Zａ-ｚＡ-Ｚ])+$/u);
  return LETTER.test(value);
}

/**
 * 文字と空白のみの（絵文字や記号などを含まない）文字列であるかを判別する。
 * 2021/10/18現在：使用なし
 * @param value チェックしたい文字列。
 */
export function isLetterWithSpace(value: string) {
  // eslint-disable-next-line no-irregular-whitespace
  const FULL_NAME_REGEX = /^(\p{Script=Hiragana}|\p{Script_Extensions=Katakana}|\p{Script_Extensions=Han}|[a-zA-Zａ-ｚＡ-Ｚ0-9０-９])+[ |　]?(\p{Script=Hiragana}|\p{Script_Extensions=Katakana}|\p{Script_Extensions=Han}|[a-zA-Zａ-ｚＡ-Ｚ0-9０-９])+$/u;
  return FULL_NAME_REGEX.test(value);
}
